import { createContext, useContext } from 'react';

/**
 * QUÉ ES UNA COSA QUE SE PUEDE ABRIR, Y CÓMO SE ABRE.
 *
 * ═══ POR QUÉ ESTO NO VIVE EN `EntityLink.tsx` ═══
 *
 * Estaba ahí, y por eso el lint del panel estaba en rojo: un archivo que
 * exporta componentes Y un contexto rompe el fast refresh de Vite. Al tocar
 * `EntityLink`, React no puede recargar solo ese componente y recarga la
 * página entera, perdiendo los filtros y el panel que tuvieras abierto.
 *
 * Es un warning, no un error, y por eso es fácil dejarlo pasar. La razón para
 * no dejarlo: el lint corre con `--max-warnings 0`, así que ese warning tenía
 * la puerta en rojo, y una puerta en rojo permanente enseña a ignorar el rojo.
 */

export type TipoDeEntidad = 'producto' | 'venta' | 'cliente' | 'paca' | 'gasto';

/** Lo que hace falta para abrir el detalle de una cosa. */
export interface Entidad {
  tipo: TipoDeEntidad;
  id: string;
  /** Lo que se lee en el chip. */
  etiqueta: string;
  /** Segunda línea en el tooltip: código, teléfono, fecha… */
  detalle?: string;
}

interface AbridorDeDetalle {
  abrir: (entidad: Entidad) => void;
}

export const DetalleContext = createContext<AbridorDeDetalle | null>(null);

/**
 * Devuelve `null` fuera de un `ConDetalle` en vez de reventar: así la misma
 * tabla se puede reusar en un sitio sin panel lateral, y los chips degradan a
 * texto plano en lugar de romper la pantalla entera.
 */
export function useAbrirDetalle(): ((e: Entidad) => void) | null {
  return useContext(DetalleContext)?.abrir ?? null;
}
